import { Icon } from '@/components/icons/Icon'
import { type Dict } from '@/defs/misc'
import { type NavItemType } from '@/defs/nav'

type Props = {
  item: NavItemType
  showCaret?: boolean
  styles: Dict<string>
}

export const NavButtonLabel = ({ item: { icon, icons, iconUrl, label }, showCaret, styles }: Props) => {
  if (!label) return null

  const iconsList = icon ? [icon] : icons

  return (
    <>
      {!!iconsList?.length && (
        <span className={styles.iconWrap}>
          {iconsList.map((icon, i) => (
            <Icon key={i} name={icon} />
          ))}
        </span>
      )}
      {iconUrl && <img alt='' className={styles.iconImage} decoding='async' loading='lazy' src={iconUrl} />}
      <span className={styles.label}>{label}</span>
      {showCaret && (
        <span className={styles.iconCaret}>
          <Icon name='caret' />
        </span>
      )}
    </>
  )
}
